import { Add } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { useFormikContext } from "formik";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSectores } from "../../../redux/actions/resolucion";
import { StyledPuestos } from "../../styled/Puestos";
import FormikAutocomplete from "../formik/FormikAutocomplete";
import NuevoSectorFormContainer from "./nuevoSector/NuevoSectorFormContainer";

const SectorFormContainer = ({
    callBack,
    disabled,
    idDependenciaEmpleador,
    label = "Sector",
    add,
}) => {
    const dispatch = useDispatch();
    const { setFieldValue } = useFormikContext();
    const sectores = useSelector((state) => state.resolucion.sectores.data);
    const [openSector, setOpenSector] = useState(false);
    return (
        <>
            <StyledPuestos.Container>
                <StyledPuestos.InputContainer>
                    <FormikAutocomplete
                        name="idSector"
                        label={label}
                        fullWidth
                        options={sectores}
                        getOptions={() =>
                            dispatch(getSectores(idDependenciaEmpleador))
                        }
                        callBack={(e) => {
                            if (callBack) callBack(e);
                        }}
                        disabled={disabled}
                    />
                </StyledPuestos.InputContainer>
                {add ? (
                    <Tooltip title="Agregar Sector">
                        <StyledPuestos.IconButton disabled={disabled} onClick={() => setOpenSector(true)}>
                            <Add />
                        </StyledPuestos.IconButton>
                    </Tooltip>
                ) : null}
            </StyledPuestos.Container>
            <NuevoSectorFormContainer
                open={openSector}
                handleClose={() => setOpenSector(false)}
                callback={(v) => {
                    dispatch(getSectores(idDependenciaEmpleador)).then((resSectores) => {
                        const sectores = resSectores?.value?.data;
                        setFieldValue("idSector", v?.value?.data);
                        if (callBack && sectores) callBack(sectores.find(p => p.id === v?.value?.data));
                    })

                }}
                idDependenciaEmpleador={idDependenciaEmpleador}
            />
        </>
    );
};

export default SectorFormContainer